<template>
    <div class="content-body">
        <div class="container pd-x-0">
            <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                <div>
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb breadcrumb-style1 mg-b-10">
                            <li class="breadcrumb-item"><a href="#">Dashboard</a></li>
                            <li class="breadcrumb-item active" aria-current="page">Rubies Corporate Internet Banking</li>
                        </ol>
                    </nav>
                    <h4 class="mg-b-0 tx-spacing--1">Internet Banking Modules</h4>
                </div>
                <div class="d-none d-md-block">
<!--                    <button class="btn btn-sm pd-x-15 btn-white btn-uppercase"><i data-feather="mail" class="wd-10 mg-r-5"></i> Email</button>-->
<!--                    <button class="btn btn-sm pd-x-15 btn-white btn-uppercase mg-l-5"><i data-feather="printer" class="wd-10 mg-r-5"></i> Print</button>-->
                    <a href="https://businessaccount.rubies.ng/" target="_blank" class="btn btn-sm pd-x-15 btn-dark btn-uppercase mg-l-5"><file-icon></file-icon> Rubies Business Account Portal</a>
                </div>
            </div>

            <!--TODO TOP CARDS-->
            <top-cards></top-cards>


        </div><!-- container -->
    </div>
</template>

<script>
    // @ is an alias to /src
    import TopCards from "../../components/card/TopCards";
    import  { FileIcon } from  "vue-feather-icons"
    export default {
        name: 'Home',
        components:{
            TopCards,
            FileIcon
        }
    }
</script>
